module.exports = __webpack_public_path__ + "img/SE5492016059.8fa943f8.png";